import { useTypeformDrawer } from '@/hooks/useTypeformDrawer';

import { Text, Row } from '@simplywallst/ui-core';
import { StyledButton } from './styled';

export const ManualPortfolioFeedbackBanner = () => {
  const makeTypeformPopup = useTypeformDrawer('c48uLkmB');
  return (
    <Row noWrap alignItem="center">
      <Text typography="xSmall" color="whiteRGBA" opacity={0.5}>
        Have feedback on the portfolio tool?{' '}
        <StyledButton
          styleType="strongLink"
          display="inline-block"
          onClick={makeTypeformPopup}
        >
          Share it here!
        </StyledButton>
      </Text>
    </Row>
  );
};
